<script>
  import { Card, CardBody, CardHeader, CardSubtitle, CardTitle, Col, Icon, Row } from 'sveltestrap';

  let currentDeviceAddress = Object.keys(Devices.deviceList).find(() => true);
  let currentDeviceNode = Strophe.getNodeFromJid(currentDeviceAddress);
  let device = Devices.deviceList[currentDeviceAddress];
  let rmaComment = '';
  let suggestedFirmware = '';

  function sendCloudSightCommand (name, topic, destination, inputs = {}) {
    let dst = cloudfriends.username().replace('@', `@${destination}.`);
    return sendCommand(name, topic, dst, inputs);
  }

  function sendCommand (name, topic, destination, inputs = {}) {
    return new Promise((resolve, reject) => {
      let ceh = new CommandEventHandler();
      ceh.commandReply = (topic, cmdResponse, from, context) => {
        let reply = cmdResponse[0].outPList;
        resolve({
          topic: topic,
          cmdResponse: cmdResponse,
          from: from,
          context: context,
          reply: reply,
        });
      };
      ceh.commandError = (topic, cmdResponse, from, errorType, context) => {
        reject({
          topic: topic,
          cmdResponse: cmdResponse,
          from: from,
          errorType: errorType,
          context: context,
        });
      };
      let cmd = new CommandEntry(name);
      for (const [key, value] of Object.entries(inputs)) {
        cmd.setInput(key, value);
      }
      cloudfriends.sendCommand(topic, cmd, destination, ceh);
    });
  }

  sendCloudSightCommand('listFirmware', 'upgrade', 'packagemanager', { deviceJID: currentDeviceNode }).then(({ reply }) => {
    suggestedFirmware = reply.suggested;
  });
</script>
